import type { StateCreator } from 'zustand';
import { crossSellStags } from '@/helpers/conf';
import { groupMemberSwedish } from '@/helpers/user';
import { generateLoyaltyData } from '@/modules/loyalty/components/helpers';
import { STORAGE, useLocalStorageStore } from '@/store/localStorageStore';
import type { AddonsState, CommonStoreType } from '../types';

const initialState = {
  ourBenefits: null,
  vip: null,
  aboutUs: null,
  regBannerActionBtnRect: null,
  isNavigateOnCloseRegistration: false,
  thirdPartySummaries: undefined,
  pendingThirdPartySummaries: false,
  currentCancelBonusData: undefined,
  loyaltyData: null,
  loyaltyPending: true,
  isVerifyMessage: false,
  isPrefilledNdbCoupon: false,
  prefilledNdbCoupon: undefined,
  isKnowYourLimit: false,
  afterRegStep: false,
  livespinsSDK: null,
  regBanner: null,
  registrationTheme: 'default',
};

export const useAddonsSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  AddonsState
> = (_, getState) => ({
  ...initialState,
  getLoyaltyData: () => {
    const { user, compPoints } = getState() || {};

    return groupMemberSwedish(user)
      ? undefined
      : generateLoyaltyData(compPoints);
  },

  availableCrossSell: crossSellStags.some(
    (stag) => stag === useLocalStorageStore.getState().get(STORAGE.SPECIAL_STAG)
  ),
});
